module.exports = __webpack_public_path__ + "static/media/icon-piece1-6.dd963f5c.png";